<template>
  <div>
    <form v-if="addingComment" @submit.prevent="submitComment">
      <div class="mb-2">
        <span class="font-italic ">{{ formatDate(newCommentTime) }}</span> - <span class="fas fa-user"></span> {{ currentUser.name }}
      </div>
      <textarea ref="commentTextArea" v-model="newComment" class="w-100 p-1 mb-1 lead" rows="2" :disabled="submittingComment"></textarea>
      <ul class="list-inline mb-2">
        <li class="list-inline-item">
          <button class="btn btn-default" :disabled="disableAddCommentButton">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="submittingComment && !statusChange"></span>
            Add Comment
          </button>
        </li>
        <li class="list-inline-item">
          <button class="btn btn-primary" @click="statusChange = true">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="submittingComment && statusChange"></span>
            {{ statusChangeLabel }}
          </button>
        </li>
        <li v-if="collapsible" class="list-inline-item">
          <button class="btn btn-link" @click="cancelComment">Cancel</button>
        </li>
      </ul>
    </form>
    <template v-else>
      <button class="btn btn-default" @click="showCommentForm"><span class="fas fa-comment"></span> Add a comment</button>
    </template>
  </div>
</template>

<script>
  import dayjs from 'dayjs';

  export default {
    name: "CommentForm",
    props: {
      currentUser: {
        type: Object,
        default: function () {
          return {};
        }
      },
      incident: {
        type: Object,
        required: true,
      },
      collapsible: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        addingComment: !this.collapsible,
        newCommentTime: new Date(),
        newComment: "",
        submittingComment: false,
        statusChange: false,
      }
    },
    computed: {
      disableAddCommentButton() {
        return this.newComment.length === 0 || this.submittingComment;
      },
      statusChangeLabel() {
        return this.incident.status === 'Resolved' ? 'Reopen' : 'Resolve';
      }
    },
    watch: {
      newComment() {
        const textarea = this.$refs.commentTextArea;
        textarea.style.height = "auto"; // reset
        textarea.style.height = `${textarea.scrollHeight}px`;
      }
    },
    methods: {
      formatDate(date) {
        return dayjs(date).format('MM/DD/YY hh:mm A');
      },
      showCommentForm() {
        this.newCommentTime = new Date();
        this.addingComment = true;
        this.$nextTick(() => {
          this.$refs.commentTextArea.focus();
        })
      },
      cancelComment() {
        this.newComment = '';
        this.submittingComment = false;
        this.statusChange = false;
        if (this.collapsible) {
          this.addingComment = false;
        }
      },
      async submitComment(e) {
        this.submittingComment = true;
        const url = `${this.$config.baseUrl}/api/v2/incidents/${this.incident.id}?include=${this.$config.apiIncludes}`;
        let body = [];
        if (this.newComment.length > 0) {
          body.push({
            "path": "/comments",
            "op": "add",
            "value": this.newComment,
          });
        }
        if (this.statusChange) {
          const value = this.incident.status === 'Resolved' ? 'Open' : 'Resolved';
          body.push({
            "path": "/status",
            "op": "replace",
            "value": value,
          });
        }

        // if they click add comment but comment is empty, no-op
        if (body.length === 0) {
          return;
        }

        const res = await fetch(url, {
          method: "PATCH",
          body: JSON.stringify(body)
        });
        if (!res.ok) {
          alert('Something went wrong, please refresh the page and try again');
          return;
        }
        const data = (await res.json()).data;
        this.cancelComment();
        this.$emit('comment-success', data);
      }
    }
  }
</script>

<style scoped>
  textarea {
    resize: none;
  }
</style>